<span #tooltip>
    <bazis-icon
        part="icon"
        [size]="iconSize()"
        [icon]="icon()"
    ></bazis-icon>
    <bazis-tooltip
        [part]="type() === 'dark' ? 'tooltip' : 'tooltip light'"
        [reference]="tooltip"
        [eventType]="tooltipEventType()"
        [attr.placement]="tooltipPlacement()"
        [placement]="tooltipPlacement()"
        [offset]="tooltipOffset()"
        [isStatic]="tooltipIsStatic()"
        [type]="type()"
        [innerHTML]="tooltipText()"
        [allowClickInside]="tooltipEventType() === 'click'"
    ></bazis-tooltip>
</span>
